const isTrueFilter = function(input) {
    switch (input) {
      case 'true':
        return '是'
      case 'false':
        return '否'
      default:
        return '否'
    }
}

let filterObj = {}
filterObj.isTrue = isTrueFilter

export default filterObj
